<template>
  <scout-form
    :is-modified="!!value"
    label="希望する会社のタイプ"
  >
    <div class="boss-layout boss-layout-start">
      <div>
        <select
          :value="value"
          class="boss-input-select"
          data-default="false"
          @change="$emit('input', Number($event.target.value) || null)"
        >
          <option
            value=""
          >
            指定なし
          </option>
          <option
            v-for="(option ,i) in companyStylesMaster"
            :key="i"
            :value="option.id"
            :data-test="`option-${option.id}`"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  computed: {
    ...mapGetters([
      'companyStylesMaster'
    ])
  }
}
</script>
